import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-batch-del-purch-line',
  templateUrl: './batch-del-purch-line.component.html',
  styleUrls: ['./batch-del-purch-line.component.css']
})
export class BatchDelPurchLineComponent implements OnInit {
    batchDelPurchLineKeyno;

    public selectedBgPurchLineSelection: string = '0';

    public info?: Info;

    public deleting = false;

    public rollingBack = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.batchDelPurchLineKeyno = this.stateService.getStateParams()['batchdelpurchline_keyno'];
    }

    private async loadInfo() {
        if (!!this.batchDelPurchLineKeyno) {
            this.info = (await this.datatask.Post(287, { batchdelpurchline_keyno: this.batchDelPurchLineKeyno }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.info) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(290, { batchdelpurchline_keyno: this.info.batchdelpurchline_keyno });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public async rollbackValues() {
        if (!!this.info) {
            try {
                this.rollingBack = true;

                const rollbackConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (rollbackConfirmed) {
                    const response = (await this.datatask.Post(1720, { batchdelpurchline_keyno: this.info.batchdelpurchline_keyno }))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.rollingBack = false;
            }
        }
    }

    private async init() {
        this.loadInfo();
    }

    ngOnInit() {
        this.init();
    }
}

interface Info {
    batchdelpurchline_keyno: string;
    batchdelivery_keyno: string;
    purchline_keyno: string;
    quantity_received: string;
    price_locval: string;
    price_ordval: string;
    prod_id: string;
    prod_name: string;
    note_before: string;
    purchline_note: string;
    nbr_of_stockbatches: string;
    stock_keyno: string;
    project_id_and_name: string;
    order_valuta_id: string;
    freight_eu: string;
    freight_ex_eu: string;
    customs_eu: string;
    customs_ex_eu: string;
    divcost: string;
    amount_locval: string;
    purchprice_locval: string;
    purchprice_invval: string;
    show_delete_button: string;
    purch_internal_no: string;
    show_rollback_button: string;
}
